/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd } from '@airasia-rn/ui';
import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((pd) => ({
  footerAdsContainerWeb: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
  },

  footerAdsContainerMobile: {
    flexDirection: 'column',
    justifyContent: 'center',
  },

  footerAdsItemMobile: {
    width: '100%',
  },
  footerAdsMargin: {
    gap: {
      xs: pd.ref.space.spacing40.px,
      md: pd.ref.space.spacing50.px,
    },
  },
}));
